export default "__VITE_ASSET__b757be1f__"